import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://wealthplayrepo.onrender.com/api';
const TOKEN_KEY = 'token';

// Configure axios with timeout
axios.defaults.timeout = 30000; // 30 seconds

export async function register(email: string, password: string): Promise<string> {
  try {
    const res = await axios.post(`${API_URL}/auth/register`, { 
      email, 
      password 
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return res.data.token;
  } catch (error: any) {
    console.error('Registration API error:', error);
    console.error('API URL:', `${API_URL}/auth/register`);
    throw error;
  }
}

export async function login(email: string, password: string): Promise<string> {
  const res = await axios.post(`${API_URL}/auth/login`, { email, password });
  return res.data.token;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export async function getCurrentUser() {
  const token = getToken();
  if (!token) return null;
  const res = await axios.get(`${API_URL}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}

export async function requestPasswordReset(email: string): Promise<{ message: string }> {
  const res = await axios.post(`${API_URL}/auth/forgot-password`, { email });
  return res.data;
}

export async function resetPassword(token: string, password: string): Promise<{ message: string }> {
  const res = await axios.post(`${API_URL}/auth/reset-password`, { token, password });
  return res.data;
}

export async function deleteAccount(): Promise<{ message: string }> {
  const token = getToken();
  if (!token) throw new Error('No authentication token found');
  
  const res = await axios.delete(`${API_URL}/auth/account`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
} 